export enum ClientConnectMessageName {
    Invite = 'invite',
    ClientAppInstallAndroid = 'client-app-install-android',
    ClientAppConfigAndroid = 'client-app-config-android',
    ClientAppInstallIos = 'client-app-install-ios',
    ClientAppConfigIos = 'client-app-config-ios',
}
